import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-600">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <span key={index} className="flex items-center">
            {index > 0 && (
              <i className="ri-arrow-right-s-line mx-2 text-foreground-400 text-xs"></i>
            )}
            {isLast || !item.href ? (
              <span className={isLast ? "text-foreground-900 font-medium" : "text-foreground-600"}>
                {item.label}
              </span>
            ) : (
              <Link
                to={item.href}
                className="text-foreground-600 hover:text-primary-500 transition-colors duration-200"
              >
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}